import { Record } from "immutable";

type TokenStatus = "connected" | "requiresAction" | "disconnected";

export const authorizedTokenFromJSON = (json: Partial<IAuthorizedTokenData>): AuthorizedTokenRecord => {
  const record: IAuthorizedTokenRecord = { ...(json as any) };

  if (json.id && json.id > 0) {
    record.status = json.authorized ? "connected" : "requiresAction";
  } else {
    record.status = "disconnected";
  }

  return new AuthorizedTokenRecord(record);
};

export interface IAuthorizedTokenData {
  authorized: boolean;
  id?: number;
}

export interface IAuthorizedTokenRecord {
  authorized: boolean;
  id: number;
  status: TokenStatus;
}

export const defaultAuthorizedTokenRecord: IAuthorizedTokenRecord = {
  authorized: false,
  id: 0,
  status: "disconnected",
};

export class AuthorizedTokenRecord
  extends Record<IAuthorizedTokenRecord>(defaultAuthorizedTokenRecord)
  implements IAuthorizedTokenRecord {}
